module.exports = __webpack_public_path__ + "img/tree_right_layout_icon.5cb04d0a.svg";